// extracted by mini-css-extract-plugin
export var container = "AccentColorContext-module--container--f7ab2";